import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Automation\GetAutomationByIdController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationByIdController.php
* @route '/api/automation/{automation}'
*/
const GetAutomationByIdController = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAutomationByIdController.url(args, options),
    method: 'get',
})

GetAutomationByIdController.definition = {
    methods: ["get","head"],
    url: '/api/automation/{automation}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Automation\GetAutomationByIdController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationByIdController.php
* @route '/api/automation/{automation}'
*/
GetAutomationByIdController.url = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { automation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.id
        : args.automation,
    }

    return GetAutomationByIdController.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Automation\GetAutomationByIdController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationByIdController.php
* @route '/api/automation/{automation}'
*/
GetAutomationByIdController.get = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAutomationByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Automation\GetAutomationByIdController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationByIdController.php
* @route '/api/automation/{automation}'
*/
GetAutomationByIdController.head = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAutomationByIdController.url(args, options),
    method: 'head',
})

export default GetAutomationByIdController